<template>
    <div>
      <div class="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>首页</el-breadcrumb-item>
          <el-breadcrumb-item>外文官网</el-breadcrumb-item>
          <el-breadcrumb-item>渠道管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="operating">
        <el-button
          type="primary"
          size="small"
          @click="addHandle"
        >新增渠道</el-button>
      </div>
      <div >
        <template>
          <el-table
            :data="tableData"
            stripe
            center
            border
            highlight-current-row
            style="width: 100%">
            <el-table-column
              align="center"
              prop="name"
              label="渠道名称">
            </el-table-column>
            <el-table-column
              align="center"
              label="渠道icon">
              <template slot-scope="scope">
                <el-image :src="scope.row.icon.file_path" alt="" style="height: 40px; width: 40px">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="操作"
              width="240">
              <template slot-scope="scope" >
                <el-button
                  type="primary"
                  size="small"
                  @click="updateHandle(scope.row)"
                >编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </div>
      <el-dialog title="新增渠道" :visible.sync="dialogVisible" @open="openHandle" @close="closeHandle"  :close-on-click-modal="false"  width="500px" class="padding_10">
        <el-form :model="form" label-width="80px" :rules="rules" ref="form">
          <el-form-item label="渠道名称" prop="name" >
            <el-input v-model="form.name" auto-complete="off" placeholder="请输入渠道名称"></el-input>
          </el-form-item>
          <el-form-item label="渠道icon" prop="icon_id" >
            <el-upload
              action="#"
              list-type="picture-card"
              :before-upload="beforeUpload"
              :on-change="handleChange"
              :http-request="submitUpload"
              :auto-upload="true"
              accept=".jpg,.png,.jpeg"
              :show-file-list="false"
              ref="icon">
              <img  v-if="form.icon_img" :src="form.icon_img"   style="width: 146px!important;height: 146px;">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" size="small" :loading="loading" @click="store">保 存</el-button>
          <el-button  size="small" @click="dialogVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
import {uploadImg} from '../../../api'
import {storeChannel, channels} from '../../../api/language/game'

export default {
  data () {
    return {
      tableData: [],
      dialogTitle: '',
      dialogVisible: false,
      loading: false,
      form: {
        id: 0,
        icon_id: '',
        name: '',
        icon_img: ''
      },
      file: {},
      item: {},
      rules: {
        icon_id: [
          {required: true, message: '请上传icon', trigger: 'change'}
        ],
        name: [
          {required: true, message: '请输入名称', trigger: 'blur'}
        ]
      }
    }
  },
  mounted () {
    this.setTableData()
  },
  methods: {
    updateHandle (row) {
      this.dialogVisible = true
      this.dialogTitle = '编辑渠道'
      this.form.id = row.id
      this.item = {
        name: row.name,
        icon_id: row.icon_id,
        icon_img: row.icon.file_path
      }
    },
    openHandle () {
      if (this.form.id !== 0) {
        this.form.name = this.item.name
        this.form.icon_id = this.item.icon_id
        this.form.icon_img = this.item.icon_img
      }
    },
    addHandle () {
      this.dialogVisible = true
      this.dialogTitle = '新增渠道'
    },
    setTableData () {
      channels().then(res => {
        let {status} = res
        if (status === 2000) {
          this.tableData = res.data
        } else {
          this.tableData = []
        }
      })
    },
    closeHandle () {
      this.item = {}
      this.form.id = 0
      this.form.icon_img = ''
      this.form.name = ''
      this.form.icon_id = ''
    },
    store () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.loading = true
          storeChannel(this.form).then(res => {
            let {status, message} = res
            if (status === 2000) {
              this.dialogVisible = false
              this.setTableData()
              this.form.icon_img = ''
            }
            this.$notify({
              message: message,
              type: status === 2000 ? 'success' : 'warning',
              offset: 100,
              showClose: false
            })
            this.loading = false
          })
        }
      })
    },
    // 上传前回调
    beforeUpload (file) {
      const isImg = ['image/jpeg', 'image/png', 'image/jpg'].indexOf(file.type) >= 0
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isImg) {
        this.$notify({
          message: '上传图片必须为jpg或png 格式!',
          type: 'warning',
          offset: 100,
          showClose: false
        })
      }
      if (!isLt2M) {
        this.$notify({
          message: '上传图片大小不能超过 2MB!',
          type: 'warning',
          offset: 100,
          showClose: false
        })
      }
      return isImg && isLt2M
    },
    // 上传icon文件，获取文件流
    handleChange (file) {
      this.file = file.raw
    },
    // 图片上传
    submitUpload () {
      let form = new FormData()
      // 后端接受参数 ，可以接受多个参数
      form.append('file', this.file)
      uploadImg(form).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.form.icon_id = res.data.file_id
          this.form.icon_img = res.data.file_path
        }
        this.$notify({
          message: message,
          type: status === 2000 ? 'success' : 'warning',
          offset: 100,
          showClose: false
        })
        this.$refs['icon'].clearFiles()
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/language/channel/index.vue